import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClick", "widgetLocation", "promptsHeight", "disableAnimation", "consentPromptEnabled"];
import styled from 'styled-components';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import { darken } from 'visitor-ui-component-library/utils/colors';
import { WHITE, OBSIDIAN, NEUTRAL_1600, NEUTRAL_1000, NEUTRAL_700 } from 'visitor-ui-component-library/constants/WidgetColors';
import { useCustomerAgentHover } from '../contexts/CustomerAgentHoverContext';
import SVGClose from 'visitor-ui-component-library-icons/icons/SVGClose';
import { LEFT_ALIGNED, RIGHT_ALIGNED } from 'conversations-internal-schema/widget-location/constants/WidgetLocations';
import { useUserHasRecentlyGivenConsent } from './hooks/useUserHasRecentlyGivenConsent';
import { jsx as _jsx } from "react/jsx-runtime";
const BUTTON_ABOVE_PROMPTS_OFFSET = 6;
const getAnimationStyles = (promptsHeight, isHoverActive, disableAnimation = false, hasRecentlyGivenConsent = false) => {
  const animationHeight = promptsHeight ? promptsHeight + BUTTON_ABOVE_PROMPTS_OFFSET : 0;
  if (disableAnimation) {
    return {
      bottom: `${animationHeight}px`,
      transition: 'none'
    };
  }
  if (hasRecentlyGivenConsent && isHoverActive) {
    return {
      bottom: `${animationHeight}px`,
      transition: 'none'
    };
  }
  if (!isHoverActive) {
    return {
      bottom: '0px',
      transform: 'translateY(0px)'
    };
  }
  return {
    bottom: '0px',
    transform: `translateY(-${animationHeight}px)`
  };
};
const StyledIconButton = styled(VizExIconButton)(({
  widgetLocation,
  promptsHeight,
  isHoverActive,
  disableAnimation,
  hasRecentlyGivenConsent
}) => {
  return Object.assign({
    zIndex: 999,
    position: 'absolute',
    left: widgetLocation === LEFT_ALIGNED ? '0' : 'auto',
    right: widgetLocation === RIGHT_ALIGNED ? '0' : 'auto',
    height: '20px',
    width: '20px',
    borderRadius: '20px',
    backgroundColor: WHITE,
    color: NEUTRAL_1000,
    border: `1px solid ${NEUTRAL_700}`,
    fontSize: '12px',
    boxShadow: '0px 1px 17px 3px #AC937742',
    '&:hover:enabled': {
      color: NEUTRAL_1600,
      borderColor: OBSIDIAN,
      backgroundColor: darken(WHITE, 0.02)
    },
    transition: disableAnimation ? 'none' : 'all .5s ease-in-out'
  }, getAnimationStyles(promptsHeight, isHoverActive, disableAnimation, hasRecentlyGivenConsent));
});
const CloseButton = _ref => {
  let {
      onClick,
      widgetLocation,
      promptsHeight = 0,
      disableAnimation = false,
      consentPromptEnabled = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isHoverActive
  } = useCustomerAgentHover();
  const hasRecentlyGivenConsent = useUserHasRecentlyGivenConsent(consentPromptEnabled, isHoverActive);
  return /*#__PURE__*/_jsx(StyledIconButton, Object.assign({
    shape: "circle",
    onClick: onClick,
    widgetLocation: widgetLocation,
    promptsHeight: promptsHeight,
    isHoverActive: isHoverActive,
    disableAnimation: disableAnimation,
    hasRecentlyGivenConsent: hasRecentlyGivenConsent
  }, rest, {
    children: /*#__PURE__*/_jsx(VizExIcon, {
      icon: /*#__PURE__*/_jsx(SVGClose, {
        width: 10,
        height: 10
      })
    })
  }));
};
CloseButton.displayName = 'VisitorWidgetCloseButton';
export default CloseButton;